import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import FirebaseFirestoreService from "../../firebase-service/FirebaseFirestoreService";
import { updateFormDataRedux } from "../../actions/formData.actions";

export const BubbleUser = ({ content, id }) => {
  const dispatch = useDispatch();
  const [text, setText] = useState(content);
  const [isModifying, setIsModifying] = useState(false);
  const user = useSelector((state) => {
    return state.user;
  });
  const formDataDic = useSelector((state) => {
    return state.formDataDic;
  });
  const handleChangeText = (e) => {
    if (!isModifying) {
      setIsModifying(true);
    }
    setText(e.target.value);
  };
  const sendRequest = () => {
    if (text.length > 10) {
      const tabDiscussion = formDataDic?.formData?.map((item) => {
        if (item.id === id) {
          return { ...item, answer: text }; // Mettre à jour le texte si l'ID correspond
        } else {
          return item; // Retourner l'élément inchangé si l'ID ne correspond pas
        }
      });
      FirebaseFirestoreService.updateDocumentField(
        "formDataCollec",
        formDataDic?.id,
        tabDiscussion
      )
        .then(() => {
          const queries = [
            {
              field: "uid",
              condition: "==",
              value: formDataDic.uid,
            },
          ];
          FirebaseFirestoreService.readDocuments({
            collectionName: "formDataCollec",
            queries: queries,
          })
            .then((data) => {
              setIsModifying(false);
              dispatch(updateFormDataRedux(data[0]));
            })
            .catch((error) => {
              console.log("Message: ", error);
            });
        })
        .catch((error) => {
          console.log("Message non envoyé: ", error);
        });
    }
  };
  return (
    <div className="chat chat-end w-full">
      <div className="chat-image avatar">
        <div className="w-10 rounded-full">
          <img alt="utilisateur" src={user?.photoURL} />
        </div>
      </div>
      <div className="chat-header">{user.displayName}</div>
      <textarea
        value={text}
        onChange={handleChangeText}
        className="chat-bubble bg-slate-100 text-black w-full focus:chat-bubble-warning border-black border-2"
        placeholder="taper votre réponse ici..."
      ></textarea>
      {isModifying && (
        <button
          className="btn btn-xs btn-warning my-2"
          onClick={() => {
            sendRequest();
          }}
        >
          Enregistrer modification
        </button>
      )}
    </div>
  );
};
